import { render, staticRenderFns } from "./OrganizerNavPanel.vue?vue&type=template&id=da81cc88"
import script from "./OrganizerNavPanel.vue?vue&type=script&lang=ts"
export * from "./OrganizerNavPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports